import joypixels from 'emoji-toolkit';

export function unicodeToOutput(content) {
    return twemoji.parse(
        content,
        { base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/' },
    );
}

export function unicodeToShortname(content) {
    return joypixels.toShort(content);
}

export function shortnameToUnicode(content) {
    return joypixels.shortnameToUnicode(content);
}

export function shortnameToOutput(content) {
    return unicodeToOutput(shortnameToUnicode(content));
}
